"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var PopupContent_1 = __importDefault(require("@ntuctech/devex-tangram/PopupContent"));
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var ModalContent = function (props) {
    var children = props.children, forwardedRef = props.forwardedRef, classNameProp = props.className, others = __rest(props, ["children", "forwardedRef", "className"]);
    return (React.createElement(PopupContent_1.default, __assign({ ref: forwardedRef, className: clsx_1.default(classNameProp, '_ndsModalContent') }, others), children));
};
ModalContent.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]).isRequired,
    forwardedRef: prop_types_1.default.any,
    className: prop_types_1.default.string
};
ModalContent.defaultProps = {
    forwardedRef: React.createRef(),
    className: null
};
exports.default = reactHelpers_1.withForwardedRef(ModalContent);
//# sourceMappingURL=ModalContent.js.map